// lib/api.js
import config from '@/localconfig';
const urlBase = config.BASE_URL;

export const fetchIntermediaryArticles = async () => {
  try {
    const response = await fetch(urlBase + '/api/v1/intermediary');
    const data = await response.json();
    return data;
} catch (error) {
    console.log('Error fetching articles:', error);
}
};

export const fetchIntermediaryContentByUrl = async (url, locale) => {
    try {
      let apiUrl = urlBase + '/api/v1/intermediary/fetch_by_url?url=' + encodeURIComponent(url);
      if (locale) {
        apiUrl += '&locale=' + encodeURIComponent(locale);
      }
      console.log("apiUrl",apiUrl)
      const response =  await fetch(apiUrl);      

      if (!response.ok) {
        console.log(`HTTP error! Status: ${response.status}`);
      }
      const articleData = await response.json();
      console.log("articleData",articleData)
      return articleData;
    } catch (error) {
      console.log(`Error in fetchArticleBySlug: ${error.message}`);
      return {contentBlock: {}}
    }
  };
export const fetchArticleSlugs = async (slug) => {
    try {
      const response = await fetch(urlBase + '/api/v1/intermediary');
      
      if (!response.ok) {
        console.log('Failed to fetch calculator article by slug');
      }
  
      const articleData = await response.json();
      return articleData;
    } catch (error) {
      console.log(`Error in fetchArticleBySlug: ${error.message}`);
    }
  };
